import React from "react";
import { default as WCard } from "@mui/material/Card";

function Card(props) {
  return <WCard {...props} />;
}

export default Card;
